/* eslint-disable no-restricted-globals */

const mode = import.meta.env?.MODE ?? 'development';
const { hostname, protocol } = location;
let localHostname = hostname;
let matomoSiteId = null;
let matomoDebug = false;
let env = mode;

const apiSuffix = '';
const localTomcatPort = '8080';
const matomoHost = 'https://analyze.spicetech.net';

if (mode === 'development' || mode === 'test') {
  matomoSiteId = 2;
  matomoDebug = true;
}

// map frontend hosts to the matching matomo site
if (hostname === 'designsystem.bbh-solutions.de') {
  localHostname = 'app.bbh-solutions.de';
  matomoSiteId = 4;
  env = 'production';
}
if (hostname === 'lemon-designsystem.spicetech.de') {
  localHostname = 'lemon.spicetech.de';
  matomoSiteId = 4;
  env = 'production';
}
if (hostname === 'lemon-designsystem-backup.spicetech.de') {
  localHostname = 'lemon-backup.spicetech.de';
  matomoSiteId = 3;
  env = 'backup';
}
if (hostname === 'lemon-lab.spicetech.net') {
  localHostname = 'lemon-lab-app.spicetech.net';
  matomoSiteId = 1;
  matomoDebug = true;
  env = 'lab';
}
if (hostname === 'lemon-designsystem-test.spicetech.de') {
  localHostname = 'lemon-test.spicetech.de';
  matomoSiteId = 1;
  matomoDebug = true;
  env = 'lab';
}

const apiUrl = `${protocol}//${localHostname}`;

export default {
  api:
    mode === 'development' || mode === 'test'
      ? `${apiUrl}:${localTomcatPort}${apiSuffix}`
      : apiUrl + apiSuffix,
  sentry: {
    env
  },
  // keep matomo off when the current host is not mapped
  matomo:
    matomoSiteId === null
      ? null
      : {
        host: matomoHost,
        siteId: matomoSiteId,
        debug: matomoDebug
      }
};
